<div class="my-modal">
  <div>
    <h4 class="titleModal">
      {{ data.event_name[userLanguage] || data.event_name[languages.default] }}
    </h4>
    <ng-container>
      <!-- Always select IT for now -->
      <p>
        {{
          data.event_long_description[userLanguage] ||
            data.event_long_description[languages.default]
        }}
      </p>
    </ng-container>
  </div>
  <div class="mini-button-container">
    <button class="mini-button annulla" (click)="close()">
      {{ "close" | translate }}
    </button>
    <button class="mini-button conferma" (click)="save()">
      {{ "continue" | translate }}
    </button>
  </div>
</div>
